<template>

    <div v-if="childrens">
        <draggable :list="childrens" :options="{animation:400}" :tag="'div'" @change="update">
            <div v-bind:key="i" v-for="(children, i) in childrens">
                <b-list-group-item class="d-flex justify-content-between align-items-center">
                    <router-link :to="{ name: 'FormCategory', params: {action: 'edit', type: 'sub-sub-category', id: children.id}}"> - - {{children.name}}</router-link>
                    <b-badge variant="primary" pill><i class="fas fa-arrows-alt-v"></i></b-badge>
                </b-list-group-item>
            </div>
        </draggable>
    </div>

</template>

<script>
    import draggable from 'vuedraggable';
    import {SET_ALERT} from "@/core/services/store/alert.module";
    import {SORT_SEB_SUB_CATEGORY} from "../../../../core/services/store/categories.module";
    export default {
        name: "SubSubCategoryList",
        components:{
            draggable
        },
        props: [ 'childrens', 'id'],
        methods: {

            update(){
                this.childrens.map((childrens, index) => {
                    childrens.sort = index + 1;
                });
                const categories = this.childrens;
                const id = this.id;
                this.$store.dispatch(SORT_SEB_SUB_CATEGORY, {categories, id})
                    .catch(() => {
                        this.showAlert('Ошибка, проверьте соединение с интернетом', 'danger', 'toast');
                    });
            },

            showAlert(text, variant, type) {
                this.$store.commit(SET_ALERT, {text, variant, type});
            },
        }
    }
</script>

<style scoped>

    .badge-primary i{
        color: #ffffff;
    }

    .badge-pill{
        border-radius: 0.3rem;
    }
</style>